import _taggedTemplateLiteral from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/UDFGE-ESHOP4-JOB1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import styled from 'styled-components';
const SCNoResultsFoundWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding-top: 100px;\n  padding-bottom: 100px;\n  text-align: center;\n"])));
export { SCNoResultsFoundWrapper };